export default __webpack_public_path__ + "static/media/Graph2.77ab39d2.svg";